import { Component, getComponentByDomNode, EventListener } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import { AnimatedSvg } from '@swisslife/patterns-base/src/atoms/animated-svg/js/animated-svg';

enum States {}

enum Selectors {}

// The @Component decorator will connect the class with `data-g-name="DistributionTeaser"` elements.
@Component('DistributionTeaserItem')
export class DistributionTeaserItem extends GondelJqueryComponent {
	private AnimatedSvg: AnimatedSvg;

	public async sync() {
		const $animatedSvg = $('.js-a-animated-svg', this.$ctx);
		if ($animatedSvg.length > 0) {
			this.AnimatedSvg = getComponentByDomNode<AnimatedSvg>($('.js-a-animated-svg', this.$ctx).get(0));
		}
	}

	@EventListener('mouseover')
	public _handleMouseOver() {
		if (!this.AnimatedSvg) {
			return;
		}
		this.AnimatedSvg.play();
	}
}
